angular.module('impactx.list').filter('ixGlobalListFilter', function($filter, $injector){
    return function(input, predicate){
        var localPredicate = JSON.parse(JSON.stringify(predicate));
        var tempFilteredAll = input;
        var keys = Object.keys(localPredicate);
        for (var j = 0; j < keys.length; j++)
        {
            var tempFilteredOneFilter = [];
            var column = Object.keys(localPredicate)[j];
            var predicateObj = localPredicate[column];
            var oneSet = false;
            var isArray = false;
            if (Array.isArray(predicateObj))
            {
                isArray = true;
                tempFilteredOneFilter = $filter('filter')(tempFilteredAll, function (value)
                {
                    for (var i = 0; i < predicateObj.length; i++)
                    {
                        oneSet = true;
                        if (localPredicate[column][i][column] === value[column])
                        {
                            return true;
                        }
                    }
                });
            }
            if (isArray)
            {
                tempFilteredAll = oneSet ? tempFilteredOneFilter : tempFilteredAll;
                localPredicate[column] = undefined;
            }
        }
        tempFilteredAll = $filter('filter')(tempFilteredAll, localPredicate);
        return tempFilteredAll;
    }
});